import { ChangeEvent, useState, useRef, useEffect } from "react";
import styles from "./styles.module.scss";
import { FiSearch, FiChevronDown } from "react-icons/fi";
import classNames from "classnames";

type SearchOption = {
  value: string;
  label: string;
};

interface SearchProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  className?: string;

  searchBy: string;
  onSearchByChange: (value: string) => void;
  searchOptions: SearchOption[];
}

const Search = ({
  value,
  onChange,
  placeholder,
  className,
  searchBy,
  onSearchByChange,
  searchOptions,
}: SearchProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const selectedOption = searchOptions.find((opt) => opt.value === searchBy);

  // Close on outside click
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={classNames(styles.searchContainer, className)}>
      {/* 🔍 SEARCH ICON */}
      <div className={styles.searchIconWrapper}>
        <FiSearch className={styles.searchIcon} />
      </div>

      {/* 🔽 DROPDOWN */}
      <div
        className={styles.dropdown}
        onClick={() => setIsOpen((prev) => !prev)}>
        <span className={styles.dropdownValue}>{selectedOption?.label}</span>
        <FiChevronDown
          className={classNames(styles.chevron, {
            [styles.open]: isOpen,
          })}
        />

        {isOpen && (
          <div className={styles.dropdownMenu}>
            {searchOptions.map((opt) => (
              <div
                key={opt.value}
                className={styles.dropdownItem}
                onClick={(e) => {
                  e.stopPropagation();
                  onSearchByChange(opt.value);
                  setIsOpen(false);
                }}>
                {opt.label}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* 🔎 INPUT */}
      <input
        type="text"
        className={styles.searchInput}
        value={value}
        onChange={onChange}
        placeholder={placeholder || "بحث .."}
        dir="rtl"
      />
    </div>
  );
};

export default Search;
